(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[39796,65250],{

/***/ 39796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BusinessCopyMachinesWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
;// CONCATENATED MODULE: ./src/components/businesscopymachines/logo/index.tsx


function BusinessCopyMachinesLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "1038",
        height: "84",
        viewBox: "0 0 1038 84",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_336)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M55.2955 29.9263C56.6374 29.9211 57.9509 30.3121 59.0714 31.0503V19.5998C59.0714 19.1039 58.9737 18.6129 58.784 18.1548C58.5942 17.6967 58.3161 17.2805 57.9655 16.9298C57.6149 16.5792 57.1986 16.3011 56.7405 16.1113C56.2824 15.9216 55.7914 15.8239 55.2955 15.8239H54.3121C54.3144 15.5595 54.2643 15.2973 54.1647 15.0523C54.0651 14.8074 53.9181 14.5846 53.7319 14.3968C53.5458 14.2091 53.3243 14.06 53.0802 13.9583C52.8362 13.8566 52.5744 13.8042 52.31 13.8042H49.6581C49.3937 13.8042 49.1319 13.8566 48.8878 13.9583C48.6438 14.06 48.4223 14.2091 48.2361 14.3968C48.05 14.5846 47.9029 14.8074 47.8033 15.0523C47.7037 15.2973 47.6537 15.5595 47.656 15.8239H43.8801C43.8801 15.2883 43.6673 14.7745 43.2886 14.3958C42.9098 14.017 42.3961 13.8042 41.8605 13.8042H39.2261C38.9603 13.8019 38.6966 13.8525 38.4505 13.9532C38.2044 14.0539 37.9808 14.2026 37.7928 14.3906C37.6048 14.5786 37.4561 14.8022 37.3554 15.0482C37.2548 15.2943 37.2041 15.558 37.2065 15.8239H33.8345C33.3187 15.8239 32.808 15.722 32.3317 15.5241C31.8554 15.3262 31.4229 15.0361 31.059 14.6706C30.6951 14.3051 30.407 13.8713 30.2112 13.3941C30.0154 12.9169 29.9159 12.4058 29.9182 11.89L51.9236 5.3744C52.3218 5.25562 52.6566 4.9835 52.8542 4.61792C53.0518 4.25234 53.0961 3.82323 52.9773 3.42499C52.8585 3.02675 52.5864 2.692 52.2209 2.49438C51.8553 2.29677 51.4262 2.25249 51.0279 2.37126L29.9533 8.60583V6.07689C29.9627 5.57218 29.8708 5.0707 29.6831 4.60212C29.4953 4.13354 29.2155 3.70737 28.8602 3.34879C28.5049 2.99022 28.0813 2.70653 27.6145 2.5145C27.1477 2.32246 26.647 2.22598 26.1423 2.23076H4.54078C3.54238 2.25381 2.59377 2.67145 1.90257 3.39227C1.21137 4.11309 0.833878 5.07839 0.852724 6.07689V19.5822V31.0328C1.97096 30.2897 3.28601 29.8982 4.6286 29.9088L55.2955 29.9263ZM36.4162 23.0244C36.4162 23.232 36.3753 23.4375 36.2959 23.6293C36.2164 23.821 36.1 23.9953 35.9532 24.1421C35.8064 24.2888 35.6322 24.4053 35.4404 24.4847C35.2487 24.5641 35.0432 24.605 34.8356 24.605H24.9832C24.595 24.5639 24.2357 24.3806 23.9746 24.0904C23.7134 23.8002 23.569 23.4236 23.569 23.0332C23.569 22.6428 23.7134 22.2662 23.9746 21.976C24.2357 21.6858 24.595 21.5025 24.9832 21.4614H34.8356C35.2518 21.4613 35.6511 21.6255 35.9471 21.9181C36.243 22.2107 36.4115 22.6082 36.4162 23.0244V23.0244ZM10.9686 5.05828C11.2826 5.0548 11.5906 5.145 11.8532 5.31733C12.1158 5.48966 12.3211 5.73633 12.4429 6.02585C12.5647 6.31537 12.5975 6.63462 12.5371 6.94286C12.4767 7.25109 12.3258 7.53432 12.1037 7.75642C11.8816 7.97853 11.5983 8.12942 11.2901 8.18985C10.9819 8.25028 10.6626 8.2175 10.3731 8.0957C10.0836 7.9739 9.83689 7.76859 9.66456 7.50599C9.49223 7.24338 9.40205 6.93539 9.40552 6.62131C9.40552 6.20677 9.57019 5.8092 9.86332 5.51608C10.1564 5.22295 10.554 5.05828 10.9686 5.05828ZM5.34864 5.05828C5.66272 5.0548 5.97072 5.145 6.23332 5.31733C6.49592 5.48966 6.70123 5.73633 6.82303 6.02585C6.94483 6.31537 6.97761 6.63462 6.91718 6.94286C6.85676 7.25109 6.70587 7.53432 6.48377 7.75642C6.26167 7.97853 5.97842 8.12942 5.67019 8.18985C5.36196 8.25028 5.0427 8.2175 4.75318 8.0957C4.46366 7.9739 4.217 7.76859 4.04466 7.50599C3.87233 7.24338 3.78214 6.93539 3.78561 6.62131C3.78561 6.20677 3.95028 5.8092 4.24341 5.51608C4.53653 5.22295 4.9341 5.05828 5.34864 5.05828V5.05828Z",
                        fill: "#FF7A00"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M55.2955 47.172C56.6356 47.1789 57.9457 47.5689 59.0714 48.296V36.8455C59.0714 36.3496 58.9737 35.8586 58.784 35.4005C58.5942 34.9424 58.3161 34.5261 57.9655 34.1755C57.6148 33.8249 57.1986 33.5468 56.7405 33.357C56.2824 33.1672 55.7914 33.0696 55.2955 33.0696H4.54077C3.53934 33.0696 2.57894 33.4674 1.87082 34.1755C1.16271 34.8836 0.764893 35.844 0.764893 36.8455V48.296C1.88672 47.5606 3.19938 47.1698 4.54077 47.172H55.2955ZM24.9832 38.3909H34.8356C35.0559 38.3676 35.2788 38.3909 35.4895 38.4592C35.7003 38.5276 35.8944 38.6395 36.0591 38.7877C36.2239 38.936 36.3556 39.1172 36.4458 39.3196C36.5359 39.522 36.5825 39.7411 36.5825 39.9627C36.5825 40.1844 36.5359 40.4035 36.4458 40.6059C36.3556 40.8083 36.2239 40.9895 36.0591 41.1378C35.8944 41.286 35.7003 41.3979 35.4895 41.4663C35.2788 41.5346 35.0559 41.5579 34.8356 41.5346H24.9832C24.595 41.4935 24.2357 41.3102 23.9745 41.0199C23.7134 40.7297 23.569 40.3531 23.569 39.9627C23.569 39.5724 23.7134 39.1958 23.9745 38.9055C24.2357 38.6153 24.595 38.432 24.9832 38.3909V38.3909Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M59.0714 55.1631V54.0918C59.0668 53.0918 58.6675 52.1341 57.9604 51.427C57.2533 50.7198 56.2955 50.3205 55.2955 50.3159H4.54077C3.53934 50.3159 2.57894 50.7137 1.87082 51.4218C1.16271 52.13 0.764893 53.0904 0.764893 54.0918V65.5599C1.8845 64.8197 3.19863 64.4285 4.54077 64.4359H55.2955C56.6374 64.4306 57.9509 64.8216 59.0714 65.5599V55.1631ZM34.8356 58.3243H24.9832C24.595 58.2832 24.2357 58.0999 23.9745 57.8097C23.7134 57.5194 23.569 57.1429 23.569 56.7525C23.569 56.3621 23.7134 55.9855 23.9745 55.6953C24.2357 55.4051 24.595 55.2217 24.9832 55.1807H34.8356C35.0559 55.1573 35.2788 55.1806 35.4895 55.249C35.7003 55.3173 35.8944 55.4292 36.0591 55.5775C36.2239 55.7257 36.3556 55.9069 36.4458 56.1093C36.5359 56.3117 36.5825 56.5309 36.5825 56.7525C36.5825 56.9741 36.5359 57.1932 36.4458 57.3956C36.3556 57.5981 36.2239 57.7792 36.0591 57.9275C35.8944 58.0757 35.7003 58.1876 35.4895 58.256C35.2788 58.3243 35.0559 58.3476 34.8356 58.3243V58.3243Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M132.973 20.7584C132.987 22.2238 132.744 23.6803 132.253 25.0611C131.793 26.3204 131.147 27.5041 130.339 28.5736C129.574 29.5689 128.69 30.4656 127.704 31.243C126.802 31.9656 125.824 32.5897 124.789 33.1046C127.733 33.9427 130.361 35.6358 132.341 37.9693C134.514 40.7116 135.613 44.1519 135.432 47.6461C135.445 50.0504 134.998 52.435 134.115 54.671C133.218 56.8725 131.795 58.8204 129.97 60.3436C127.873 62.0718 125.448 63.3564 122.84 64.1195C119.493 65.0982 116.017 65.5602 112.531 65.4893H87.9436V4.30261H112.899C119.731 4.30261 124.789 5.81296 128.073 8.79853C129.704 10.3209 130.986 12.178 131.832 14.2423C132.678 16.3067 133.067 18.5295 132.973 20.7584V20.7584ZM112.987 29.2058C115.226 29.302 117.433 28.6468 119.257 27.3442C120.112 26.6199 120.781 25.7015 121.209 24.6658C121.637 23.6301 121.81 22.5072 121.716 21.3906C121.766 20.367 121.578 19.3457 121.167 18.4071C120.755 17.4684 120.132 16.6381 119.345 15.9815C117.493 14.5935 115.21 13.9032 112.899 14.0321H99.4468V29.2058H112.987ZM112.355 55.8301C115.384 56.0069 118.386 55.173 120.89 53.4592C121.89 52.7163 122.693 51.7413 123.232 50.6184C123.77 49.4955 124.028 48.2584 123.981 47.0139C124.037 45.7995 123.777 44.5915 123.225 43.508C122.674 42.4244 121.852 41.5024 120.838 40.832C118.176 39.2966 115.124 38.5704 112.057 38.7421H99.4293V55.8301H112.355Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M171.592 21.672H183.219V65.5775H172.962L171.68 59.8522C171.09 60.7514 170.388 61.5717 169.59 62.2934C168.701 63.1215 167.73 63.857 166.693 64.4886C165.593 65.1606 164.412 65.6916 163.18 66.0692C161.855 66.4774 160.475 66.6788 159.088 66.6664C157.022 66.7895 154.952 66.4815 153.011 65.7619C151.07 65.0424 149.3 63.9269 147.813 62.4865C145.155 59.6883 143.827 55.5378 143.827 50.035V21.672H155.4V49.6486C155.214 51.7835 155.841 53.91 157.156 55.6022C157.844 56.2319 158.655 56.713 159.537 57.0151C160.42 57.3173 161.355 57.4342 162.284 57.3584C164.184 57.3584 166.033 56.7421 167.553 55.6022C169.131 54.4401 170.538 53.0627 171.733 51.5102L171.592 21.672Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M207.946 57.6394C209.848 57.7886 211.753 57.3991 213.443 56.5154C213.992 56.1987 214.446 55.7392 214.755 55.1857C215.064 54.6323 215.218 54.0055 215.199 53.3718C215.216 52.5412 214.993 51.7234 214.557 51.0163C214.121 50.3093 213.49 49.7429 212.741 49.3851C210.698 48.316 208.55 47.4625 206.33 46.8386C204.54 46.3197 202.781 45.6982 201.062 44.977C199.511 44.3256 198.071 43.4369 196.794 42.3427C195.59 41.295 194.615 40.0094 193.932 38.5668C193.188 36.9123 192.828 35.1113 192.878 33.2982C192.818 31.4814 193.21 29.6782 194.02 28.0505C194.829 26.4228 196.03 25.0216 197.514 23.9726C201.252 21.5187 205.677 20.3248 210.141 20.5656C212.732 20.5692 215.318 20.7984 217.869 21.2505C220.435 21.7008 222.916 22.5418 225.227 23.7443L222.593 32.2971C220.778 31.3957 218.854 30.7345 216.868 30.3301C214.866 29.8943 212.823 29.6706 210.774 29.6628C209.057 29.5386 207.337 29.8655 205.786 30.6111C205.299 30.8876 204.897 31.2926 204.624 31.782C204.352 32.2714 204.219 32.8262 204.241 33.386C204.232 34.0108 204.39 34.6267 204.699 35.17C205.007 35.7134 205.456 36.1645 205.997 36.4769C207.476 37.3359 209.042 38.0364 210.668 38.5668C212.954 39.3082 215.2 40.17 217.395 41.1485C219.177 41.9311 220.834 42.9727 222.312 44.2394C223.6 45.3762 224.635 46.7701 225.35 48.3314C226.085 50.0686 226.438 51.943 226.387 53.8284C226.398 55.6206 225.986 57.3902 225.183 58.9926C224.381 60.595 223.21 61.9848 221.768 63.0485C218.677 65.5072 214.181 66.7366 208.315 66.7366C205.443 66.7348 202.577 66.4465 199.762 65.876C197.208 65.3706 194.734 64.526 192.404 63.3646L195.038 54.5835C196.973 55.4738 198.991 56.1737 201.062 56.6734C203.305 57.2906 205.619 57.6153 207.946 57.6394Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M241.753 3.21371C242.72 3.14202 243.691 3.279 244.6 3.61534C245.509 3.95168 246.335 4.47953 247.022 5.16311C248.182 6.41104 248.812 8.06092 248.778 9.76442C248.815 11.4632 248.184 13.1086 247.022 14.3482C245.588 15.603 243.747 16.2947 241.841 16.2947C239.936 16.2947 238.095 15.603 236.66 14.3482C235.5 13.1076 234.87 11.4628 234.904 9.76442C234.872 8.06124 235.502 6.41203 236.66 5.16311C237.326 4.5006 238.123 3.98487 239 3.64912C239.878 3.31337 240.815 3.16505 241.753 3.21371V3.21371ZM247.567 65.5595H235.94V21.654H247.567V65.5595Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M271.31 65.5595H259.684V21.654H270.046L271.31 27.3618C272.096 26.5349 272.935 25.7605 273.822 25.0435C274.861 24.2101 275.972 23.4696 277.141 22.8307C278.421 22.1335 279.776 21.5855 281.18 21.1974C282.7 20.7644 284.272 20.5457 285.852 20.5476C287.805 20.4744 289.75 20.8458 291.539 21.6338C293.327 22.4217 294.914 23.6056 296.179 25.0962C298.743 28.1345 300.042 32.4021 300.042 37.9166V65.542H288.399V38.2854C288.549 36.0858 288.041 33.8912 286.941 31.9806C286.374 31.2359 285.627 30.6482 284.769 30.2733C283.912 29.8983 282.973 29.7485 282.041 29.838C279.9 29.8285 277.802 30.4384 276 31.5942C274.236 32.6751 272.654 34.0263 271.31 35.5984V65.5595Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M320.485 47.5583C320.666 49.0804 321.149 50.5509 321.906 51.8839C322.663 53.2168 323.679 54.3852 324.893 55.3208C327.155 56.9371 329.875 57.7865 332.655 57.7444C336.519 57.7632 340.327 56.8218 343.737 55.0047L346.284 63.1009C344.207 64.3162 341.956 65.2047 339.61 65.7352C336.915 66.359 334.157 66.6655 331.391 66.6484C328.045 66.7205 324.716 66.1665 321.574 65.0151C318.905 64.0076 316.503 62.4038 314.549 60.326C312.631 58.231 311.203 55.7354 310.369 53.0201C309.436 49.9226 308.98 46.7011 309.017 43.4663C308.998 40.4523 309.424 37.452 310.281 34.5623C311.068 31.9039 312.382 29.4312 314.145 27.2915C315.953 25.1714 318.224 23.495 320.783 22.3917C323.784 21.1412 327.017 20.5426 330.267 20.6355C332.975 20.588 335.665 21.0713 338.187 22.058C340.393 22.9252 342.387 24.2546 344.036 25.9568C345.668 27.6519 346.909 29.6841 347.671 31.9104C348.508 34.3028 348.924 36.8222 348.9 39.3568C348.895 40.8219 348.771 42.2843 348.532 43.7297C348.338 45.0513 348.039 46.3552 347.636 47.6286L320.485 47.5583ZM330.39 29.0302C329.058 28.9843 327.734 29.2418 326.517 29.7834C325.3 30.325 324.222 31.1365 323.365 32.1563C321.431 34.6118 320.329 37.6201 320.221 40.7442H338.047V39.5675C338.228 36.8131 337.567 34.0688 336.15 31.6996C335.497 30.8143 334.632 30.1064 333.635 29.6402C332.638 29.174 331.541 28.9643 330.442 29.0302H330.39Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M370.871 57.639C372.772 57.7882 374.677 57.3987 376.368 56.515C376.917 56.1983 377.37 55.7388 377.679 55.1854C377.988 54.6319 378.142 54.0051 378.124 53.3714C378.141 52.5408 377.918 51.723 377.482 51.016C377.046 50.3089 376.415 49.7425 375.665 49.3848C373.668 48.3245 371.567 47.4713 369.395 46.8382C367.605 46.3194 365.846 45.6978 364.127 44.9766C362.576 44.3252 361.136 43.4365 359.859 42.3423C358.66 41.2898 357.686 40.0054 356.997 38.5665C356.253 36.9119 355.893 35.1109 355.943 33.2978C355.883 31.481 356.275 29.6778 357.085 28.0501C357.894 26.4224 359.095 25.0212 360.579 23.9723C364.325 21.5226 368.754 20.3293 373.224 20.5652C375.809 20.5696 378.389 20.7988 380.934 21.2501C383.5 21.6977 385.983 22.5389 388.292 23.7439L385.658 32.2967C383.849 31.3622 381.924 30.6713 379.933 30.242C377.936 29.806 375.9 29.5823 373.856 29.5746C372.134 29.453 370.41 29.7797 368.851 30.523C368.364 30.7994 367.962 31.2044 367.689 31.6938C367.417 32.1832 367.284 32.7381 367.306 33.2978C367.297 33.9226 367.455 34.5385 367.764 35.0819C368.072 35.6252 368.521 36.0763 369.062 36.3887C370.546 37.2507 372.118 37.9514 373.751 38.4786C376.03 39.2229 378.269 40.0846 380.46 41.0603C382.244 41.8388 383.902 42.8807 385.377 44.1512C386.675 45.278 387.712 46.6745 388.415 48.2432C389.156 49.9789 389.516 51.8535 389.469 53.7402C389.482 55.5344 389.068 57.3059 388.262 58.9089C387.456 60.5119 386.28 61.9005 384.833 62.9603C381.742 65.419 377.258 66.6484 371.38 66.6484C368.513 66.6474 365.654 66.3591 362.845 65.7879C360.289 65.288 357.814 64.4432 355.486 63.2765L358.121 54.4954C360.023 55.4144 362.011 56.1438 364.057 56.6731C366.277 57.2843 368.567 57.6089 370.871 57.639V57.639Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M411.404 57.6394C413.306 57.7886 415.211 57.3991 416.901 56.5154C417.45 56.1987 417.904 55.7392 418.213 55.1857C418.522 54.6323 418.676 54.0055 418.657 53.3718C418.674 52.5412 418.451 51.7234 418.015 51.0163C417.579 50.3093 416.948 49.7429 416.199 49.3851C414.201 48.3249 412.1 47.4716 409.929 46.8386C408.139 46.3197 406.379 45.6982 404.66 44.977C403.11 44.3256 401.67 43.4369 400.393 42.3427C399.188 41.295 398.214 40.0094 397.53 38.5668C396.787 36.9123 396.427 35.1113 396.476 33.2982C396.417 31.4814 396.809 29.6782 397.618 28.0505C398.427 26.4228 399.628 25.0216 401.113 23.9726C404.85 21.5187 409.275 20.3248 413.74 20.5656C416.331 20.5692 418.916 20.7984 421.467 21.2505C424.033 21.7008 426.515 22.5418 428.826 23.7443L426.192 32.2971C424.381 31.3654 422.456 30.6746 420.466 30.2423C418.464 29.8064 416.421 29.5828 414.372 29.575C412.655 29.4508 410.936 29.7777 409.385 30.5233C408.897 30.7998 408.496 31.2048 408.223 31.6942C407.95 32.1836 407.818 32.7384 407.839 33.2982C407.83 33.923 407.989 34.5389 408.297 35.0822C408.606 35.6256 409.054 36.0767 409.595 36.3891C411.075 37.2481 412.641 37.9486 414.267 38.479C416.553 39.2204 418.798 40.0822 420.993 41.0607C422.776 41.8433 424.433 42.8849 425.911 44.1516C427.198 45.2884 428.233 46.6823 428.949 48.2436C429.683 49.9807 430.037 51.8552 429.985 53.7406C429.997 55.5328 429.585 57.3024 428.782 58.9048C427.979 60.5072 426.809 61.897 425.366 62.9607C422.275 65.4194 417.779 66.6488 411.914 66.6488C409.041 66.647 406.176 66.3587 403.361 65.7882C400.807 65.2828 398.332 64.4382 396.002 63.2768L398.637 54.4957C400.546 55.4118 402.54 56.1411 404.59 56.6734C406.811 57.2847 409.101 57.6093 411.404 57.6394Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M477.649 66.6484C473.33 66.7244 469.043 65.9052 465.057 64.2423C461.523 62.7263 458.373 60.4403 455.837 57.5511C453.3 54.603 451.383 51.1747 450.199 47.4705C447.67 39.3021 447.67 30.5599 450.199 22.3916C451.387 18.6838 453.304 15.2506 455.837 12.2934C458.374 9.40927 461.524 7.12909 465.057 5.61973C469.043 3.95692 473.33 3.13771 477.649 3.21371C480.733 3.18551 483.811 3.52152 486.816 4.21475C489.636 4.8944 492.357 5.93321 494.912 7.3057L491.997 16.28C487.883 14.0036 483.264 12.7959 478.562 12.7675C472.427 12.7675 467.82 14.7052 464.741 18.5806C461.65 22.4619 460.104 27.871 460.104 34.8432C460.104 41.8154 461.667 47.1368 464.793 51.1058C467.919 55.0749 472.503 56.9189 478.562 56.9189C480.755 56.8677 482.935 56.5672 485.06 56.0232C487.683 55.3944 490.215 54.4324 492.594 53.1606L495.334 62.2403C492.769 63.6875 490.014 64.7693 487.15 65.4541C484.044 66.2431 480.853 66.6442 477.649 66.6484V66.6484Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M499.619 43.5543C499.602 40.521 500.064 37.504 500.989 34.6152C501.823 31.9172 503.211 29.4229 505.063 27.2917C506.963 25.1802 509.301 23.5081 511.913 22.3919C518.124 19.9664 525.02 19.9664 531.231 22.3919C533.849 23.5059 536.193 25.1781 538.098 27.2917C539.95 29.4263 541.343 31.9192 542.19 34.6152C543.993 40.4621 543.993 46.7167 542.19 52.5637C541.328 55.2482 539.937 57.7325 538.098 59.8696C536.203 62.0079 533.858 63.6993 531.231 64.8221C525.02 67.2476 518.124 67.2476 511.913 64.8221C509.286 63.6993 506.94 62.0079 505.046 59.8696C503.208 57.7349 501.822 55.2495 500.971 52.5637C500.046 49.6513 499.589 46.6101 499.619 43.5543V43.5543ZM511.245 43.5543C511.06 47.1832 511.945 50.7865 513.792 53.916C514.716 55.1084 515.901 56.0735 517.255 56.7375C518.61 57.4014 520.098 57.7466 521.607 57.7466C523.116 57.7466 524.604 57.4014 525.959 56.7375C527.313 56.0735 528.498 55.1084 529.422 53.916C531.277 50.7897 532.163 47.184 531.969 43.5543C532.166 39.941 531.279 36.3512 529.422 33.2453C528.488 32.0678 527.3 31.1166 525.947 30.4627C524.594 29.8088 523.11 29.4692 521.607 29.4692C520.104 29.4692 518.621 29.8088 517.267 30.4627C515.914 31.1166 514.726 32.0678 513.792 33.2453C511.949 36.3563 511.069 39.9436 511.263 43.5543H511.245Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M552.797 21.6717H563.159L564.424 27.3794C565.118 26.5219 565.895 25.7338 566.742 25.0261C567.717 24.2092 568.764 23.4804 569.868 22.8484C571.093 22.1666 572.389 21.619 573.732 21.2151C575.179 20.7806 576.682 20.5617 578.192 20.5653C580.841 20.5089 583.458 21.151 585.779 22.4269C587.91 23.66 589.74 25.3517 591.136 27.3794C592.606 29.5576 593.681 31.9769 594.314 34.5272C595.023 37.2689 595.377 40.0902 595.368 42.922C595.423 46.3557 594.931 49.7764 593.911 53.0554C593.073 55.7529 591.732 58.2676 589.959 60.4666C588.385 62.3921 586.414 63.9555 584.181 65.0503C582.033 66.1031 579.672 66.6498 577.279 66.6485C574.447 66.7981 571.637 66.0681 569.236 64.5586C567.37 63.2568 565.727 61.6614 564.371 59.8344V82.9111H552.745L552.797 21.6717ZM564.424 44.9241C564.248 48.1616 565.177 51.3629 567.058 54.0037C567.841 55.0697 568.869 55.9322 570.055 56.519C571.24 57.1057 572.549 57.3995 573.872 57.3757C575.187 57.3771 576.489 57.1143 577.701 56.6029C578.948 56.0609 580.041 55.2158 580.879 54.1442C581.886 52.8253 582.61 51.3126 583.004 49.701C583.569 47.487 583.829 45.2063 583.777 42.922C583.98 39.5241 583.087 36.151 581.231 33.2979C580.507 32.2068 579.523 31.314 578.366 30.7005C577.21 30.0871 575.919 29.7725 574.61 29.7855C572.536 29.7466 570.502 30.361 568.797 31.5417C567.165 32.6934 565.694 34.0577 564.424 35.5985V44.9241Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M632.582 58.7458C631.979 59.6507 631.259 60.4716 630.44 61.1869C629.529 62.007 628.541 62.7363 627.489 63.3647C626.392 64.0461 625.212 64.5832 623.977 64.9628C622.632 65.3613 621.236 65.5624 619.832 65.5599C617.768 65.6849 615.701 65.3777 613.763 64.658C611.824 63.9383 610.057 62.8218 608.575 61.3801C605.906 58.5819 604.571 54.4313 604.571 48.9285V21.672H616.197V48.5597C616.011 50.6947 616.638 52.8211 617.953 54.5133C618.641 55.1431 619.452 55.6241 620.334 55.9263C621.216 56.2285 622.152 56.3453 623.081 56.2695C624.981 56.2695 626.83 55.6533 628.35 54.5133C629.924 53.3466 631.33 51.9698 632.53 50.4213V21.672H644.156V62.0651C644.219 65.5066 643.623 68.9283 642.4 72.1458C641.411 74.7365 639.843 77.0671 637.816 78.9599C635.83 80.7426 633.472 82.0622 630.914 82.8236C628.112 83.6651 625.199 84.0796 622.273 84.0529C619.028 84.0817 615.792 83.6861 612.649 82.8763C610.008 82.222 607.488 81.1489 605.185 79.6975L608.101 70.6881C610.049 71.9763 612.197 72.9319 614.458 73.5156C616.534 74.0132 618.663 74.255 620.798 74.2357C623.939 74.4462 627.052 73.5309 629.579 71.654C631.634 69.8978 632.67 66.8771 632.67 62.5217L632.582 58.7458Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M694.911 56.1989L685.287 33.8422C684.116 30.9269 683.115 28.2457 682.284 25.7987C681.493 23.34 680.738 20.7584 680.018 18.0187H679.737C679.983 19.4237 680.211 20.8989 680.422 22.4795C680.633 24.0601 680.826 25.6231 680.966 27.2037C681.107 28.7843 681.247 30.2947 681.335 31.7523C681.423 33.21 681.476 34.5096 681.476 35.6511V65.6474H669.972V4.30261H683.232L695.525 32.4021C696.696 35.0088 697.711 37.683 698.564 40.4105C699.358 42.7727 699.946 45.1996 700.32 47.6637H700.496C700.87 45.1996 701.457 42.7727 702.252 40.4105C703.112 37.6857 704.127 35.012 705.29 32.4021L717.584 4.30261H730.843V65.5596H719.393V35.5985C719.393 34.4569 719.392 33.1397 719.533 31.6996C719.673 30.2595 719.744 28.7316 719.902 27.151C720.06 25.5704 720.235 24.0074 720.446 22.4268C720.657 20.8462 720.885 19.371 721.131 17.966H720.903C720.183 20.7057 719.428 23.2347 718.637 25.7461C717.847 28.2575 716.881 30.8742 715.634 33.7895L706.01 56.234L694.911 56.1989Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M740.221 53.161C740.164 50.7443 740.644 48.3449 741.626 46.1361C742.536 44.2455 743.914 42.6192 745.63 41.4119C747.541 40.1199 749.69 39.2242 751.953 38.7776C754.702 38.2092 757.505 37.9383 760.312 37.9697H766.494V36.5121C766.494 31.8288 763.825 29.4872 758.486 29.4872C756.168 29.4703 753.86 29.7958 751.637 30.4531C749.517 31.0973 747.483 31.9935 745.578 33.1225L742.996 25.0615C745.24 23.6183 747.692 22.5285 750.267 21.8301C753.365 20.9324 756.577 20.4887 759.803 20.5129C765.915 20.5129 770.428 21.9706 773.343 24.8859C774.853 26.5155 776.018 28.4339 776.766 30.5256C777.515 32.6173 777.832 34.8389 777.699 37.0565V65.5072H767.706L766.442 59.782C765.858 60.6538 765.219 61.4868 764.527 62.2758C763.758 63.1244 762.871 63.8579 761.893 64.4535C760.796 65.1218 759.615 65.6415 758.381 65.999C756.902 66.4199 755.369 66.6211 753.832 66.5961C752.036 66.6049 750.252 66.2957 748.563 65.6829C746.952 65.0983 745.48 64.183 744.243 62.9959C742.996 61.7946 741.994 60.3633 741.292 58.7809C740.548 57.0025 740.183 55.0885 740.221 53.161V53.161ZM766.565 45.5215H760.277C757.887 45.3634 755.516 46.04 753.568 47.4357C752.793 48.0707 752.175 48.877 751.763 49.7912C751.352 50.7055 751.158 51.7027 751.198 52.7044C751.167 53.4267 751.28 54.148 751.53 54.8263C751.78 55.5046 752.163 56.1265 752.655 56.6559C753.122 57.1479 753.686 57.5366 754.313 57.7967C754.939 58.0569 755.613 58.1828 756.291 58.1662C757.729 58.1746 759.153 57.8814 760.47 57.3057C761.699 56.7516 762.808 55.9643 763.737 54.9875C764.646 54.01 765.356 52.8646 765.827 51.6156C766.321 50.3387 766.571 48.9805 766.565 47.6114V45.5215Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M809.504 57.7444C813.566 57.7908 817.571 56.7865 821.13 54.8291L823.677 63.1009C821.492 64.3616 819.121 65.2685 816.652 65.7879C814.161 66.3474 811.618 66.6359 809.065 66.6484C805.725 66.7326 802.402 66.135 799.3 64.8922C796.626 63.7719 794.229 62.0817 792.276 59.9397C790.382 57.8177 788.942 55.3317 788.043 52.6338C787.091 49.7263 786.616 46.6837 786.638 43.6244C786.62 40.5911 787.083 37.5741 788.008 34.6852C788.858 31.9717 790.284 29.4737 792.188 27.3618C794.15 25.243 796.546 23.5718 799.213 22.4619C802.378 21.2046 805.766 20.607 809.17 20.7057C811.539 20.7162 813.897 21.0111 816.195 21.5838C818.529 22.1373 820.767 23.0371 822.834 24.2533L820.375 32.3494C818.845 31.4793 817.21 30.8066 815.51 30.3474C813.692 29.8425 811.812 29.5942 809.926 29.6097C805.746 29.6097 802.748 30.8684 800.934 33.3856C799.138 36.5343 798.194 40.0963 798.194 43.721C798.194 47.3456 799.138 50.9077 800.934 54.0563C801.939 55.3399 803.25 56.3503 804.748 56.9947C806.245 57.6391 807.881 57.8969 809.504 57.7444V57.7444Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M843.118 65.5596H831.545V4.30261H843.171V27.3793C843.928 26.5553 844.738 25.781 845.594 25.0611C846.64 24.2196 847.764 23.4787 848.949 22.8483C850.276 22.1481 851.678 21.6002 853.129 21.215C854.743 20.7786 856.409 20.56 858.081 20.5652C859.982 20.521 861.868 20.9071 863.599 21.6948C865.329 22.4825 866.859 23.6513 868.074 25.1138C870.685 28.1462 871.99 32.4197 871.99 37.9342V65.5596H860.364V38.2855C860.508 36.0751 859.968 33.8741 858.819 31.9806C858.225 31.2397 857.457 30.6566 856.584 30.2829C855.711 29.9091 854.76 29.7564 853.814 29.8381C851.672 29.8285 849.574 30.4384 847.772 31.5943C846.01 32.6698 844.428 34.015 843.083 35.5809L843.118 65.5596Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M889.834 3.2138C890.786 3.15258 891.741 3.29475 892.634 3.63086C893.527 3.96697 894.339 4.48932 895.014 5.16321C896.175 6.41114 896.804 8.06101 896.771 9.76451C896.807 11.4633 896.177 13.1087 895.014 14.3482C893.58 15.6031 891.739 16.2948 889.834 16.2948C887.928 16.2948 886.087 15.6031 884.653 14.3482C883.491 13.1087 882.86 11.4633 882.897 9.76451C882.863 8.06101 883.493 6.41114 884.653 5.16321C885.329 4.48932 886.14 3.96697 887.033 3.63086C887.927 3.29475 888.881 3.15258 889.834 3.2138V3.2138ZM895.647 65.5596H884.021V21.6541H895.647V65.5596Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M919.461 65.5595H907.817V21.654H918.179L919.461 27.3617C920.24 26.5346 921.073 25.7602 921.955 25.0435C922.994 24.21 924.105 23.4696 925.274 22.8307C926.555 22.1365 927.91 21.5886 929.313 21.1974C930.839 20.7654 932.417 20.5467 934.002 20.5476C935.953 20.4745 937.895 20.846 939.681 21.6341C941.467 22.4221 943.051 23.606 944.311 25.0962C946.887 28.1286 948.175 32.4021 948.175 37.9166V65.542H936.549V38.2854C936.691 36.0864 936.184 33.8943 935.091 31.9806C934.521 31.2357 933.77 30.6483 932.91 30.2734C932.049 29.8986 931.108 29.7488 930.174 29.838C928.033 29.8315 925.936 30.4411 924.132 31.5942C922.379 32.6745 920.803 34.0192 919.461 35.5808V65.5595Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M968.618 47.5586C968.803 49.0796 969.288 50.5488 970.044 51.8812C970.801 53.2136 971.814 54.3828 973.026 55.3211C975.29 56.9341 978.009 57.783 980.788 57.7446C984.657 57.7613 988.471 56.82 991.888 55.005L994.417 63.1011C992.34 64.3164 990.089 65.2049 987.743 65.7355C985.048 66.3592 982.29 66.6657 979.524 66.6487C976.178 66.7191 972.849 66.1652 969.707 65.0154C967.037 64.0101 964.634 62.4059 962.682 60.3263C960.757 58.2359 959.329 55.7387 958.502 53.0204C957.554 49.9257 957.092 46.7029 957.132 43.4666C957.113 40.4525 957.539 37.4522 958.396 34.5626C959.19 31.9071 960.504 29.4357 962.26 27.2918C964.076 25.1798 966.345 23.505 968.899 22.3919C971.906 21.1401 975.144 20.5415 978.4 20.6357C981.102 20.5869 983.787 21.0703 986.303 22.0583C988.511 22.9295 990.51 24.2582 992.169 25.9571C993.789 27.6613 995.028 29.6908 995.804 31.9107C996.632 34.3053 997.048 36.8232 997.033 39.357C997.028 40.8222 996.904 42.2846 996.665 43.73C996.466 45.0522 996.161 46.3561 995.751 47.6288L968.618 47.5586ZM978.523 29.0305C977.191 28.9845 975.867 29.2421 974.65 29.7837C973.433 30.3253 972.355 31.1367 971.498 32.1565C969.571 34.6163 968.471 37.622 968.354 40.7444H986.092V39.5678C986.269 36.8115 985.601 34.0667 984.178 31.6999C983.529 30.8223 982.673 30.1192 981.686 29.6533C980.699 29.1875 979.613 28.9735 978.523 29.0305V29.0305Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1018.97 57.639C1020.86 57.7878 1022.76 57.3982 1024.45 56.515C1025 56.1983 1025.45 55.7388 1025.76 55.1854C1026.07 54.6319 1026.22 54.0051 1026.2 53.3714C1026.22 52.5423 1026.01 51.7249 1025.57 51.0176C1025.14 50.3104 1024.51 49.7433 1023.76 49.3848C1021.76 48.3307 1019.66 47.4777 1017.49 46.8383C1015.7 46.3159 1013.94 45.6944 1012.22 44.9766C1010.67 44.3252 1009.23 43.4365 1007.96 42.3423C1006.76 41.2898 1005.78 40.0054 1005.09 38.5665C1004.36 36.908 1004.01 35.1089 1004.06 33.2978C1004 31.481 1004.39 29.6778 1005.2 28.0501C1006.01 26.4224 1007.21 25.0212 1008.69 23.9723C1012.4 21.5377 1016.79 20.3446 1021.22 20.5652C1023.81 20.5697 1026.39 20.7988 1028.94 21.2501C1031.51 21.7004 1033.99 22.5414 1036.3 23.744L1033.67 32.2968C1031.86 31.365 1029.93 30.6742 1027.94 30.242C1025.94 29.807 1023.9 29.5833 1021.85 29.5746C1020.13 29.453 1018.4 29.7797 1016.84 30.523C1016.36 30.8024 1015.96 31.208 1015.69 31.6967C1015.41 32.1854 1015.28 32.7387 1015.3 33.2978C1015.29 33.9227 1015.45 34.5385 1015.76 35.0819C1016.06 35.6252 1016.51 36.0763 1017.05 36.3887C1018.54 37.2471 1020.11 37.9475 1021.74 38.4786C1024.03 39.2231 1026.27 40.0848 1028.47 41.0603C1030.25 41.8429 1031.9 42.8845 1033.37 44.1512C1034.67 45.2819 1035.71 46.6771 1036.43 48.2432C1037.15 49.9829 1037.5 51.8556 1037.46 53.7402C1037.47 55.5344 1037.06 57.306 1036.25 58.909C1035.45 60.512 1034.27 61.9005 1032.83 62.9604C1029.73 65.4191 1025.25 66.6484 1019.37 66.6484C1016.51 66.6457 1013.65 66.3574 1010.84 65.7879C1008.28 65.2853 1005.81 64.4406 1003.48 63.2765L1006.11 54.4954C1008.02 55.4171 1010.01 56.1466 1012.07 56.6731C1014.32 57.2941 1016.64 57.6188 1018.97 57.639V57.639Z",
                        fill: "#5367F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M241.455 0.000262331C242.648 -0.0749142 243.843 0.105538 244.961 0.529559C246.078 0.95358 247.092 1.61138 247.935 2.45896C249.403 4.01106 250.22 6.06593 250.22 8.20181C250.22 10.3377 249.403 12.3925 247.935 13.9446C246.139 15.5169 243.833 16.3836 241.446 16.3836C239.059 16.3836 236.753 15.5169 234.957 13.9446C233.501 12.3866 232.692 10.334 232.692 8.20181C232.692 6.06963 233.501 4.01699 234.957 2.45896C235.804 1.61278 236.822 0.956076 237.942 0.532239C239.062 0.108402 240.259 -0.0729103 241.455 0.000262331V0.000262331Z",
                        fill: "#FF7A00"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_336",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "1036.73",
                        height: "84",
                        fill: "white",
                        transform: "translate(0.764893)"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/styles/variables/businessCopyMachinesVariables.module.scss
var businessCopyMachinesVariables_module = __webpack_require__(98855);
var businessCopyMachinesVariables_module_default = /*#__PURE__*/__webpack_require__.n(businessCopyMachinesVariables_module);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/businessCopyMachines.tsx










const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function BusinessCopyMachinesWrapper({ children  }) {
    const { modal , setModal  } = (0,useModalContext/* useModal */.d)();
    const { visitDetails  } = (0,useDomainContext/* useDomainContext */.w)();
    const handleClose = ()=>{
        setModal({
            active: false,
            content: undefined
        });
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "BusinessCopyMachines",
                    domain: "BusinessCopyMachines.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "BusinessCopyMachines",
                    domain: "BusinessCopyMachines.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        textColor: "#686868",
                        slogan: `The Best Digital Copier Companies In ${visitDetails.region}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessCopyMachinesLogo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-6xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        textColor: (businessCopyMachinesVariables_module_default()).footerColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 98855:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gorseYellowOrange":"#ff9800","footerColor":"#2f6177"};

/***/ })

}]);